import { BDCPComparableBrotherProductsListResponse } from '../../../../models/comparable-brother-products-list-response.model';
import { BDCPProductDetails } from '../../../../models/product-details.model';
import { BDCPProductsListResponse } from '../../../../models/products-list-response.model';

export abstract class IBDCPProductsService {

    abstract getAll(): Promise<BDCPProductsListResponse>;
    abstract getBySearchValue(searchValue: string): Promise<BDCPProductsListResponse>;
    abstract getByCategory(category: string): Promise<BDCPProductsListResponse>;
    abstract getByFilter(queryParams: { [key: string]: string | string[] }): Promise<BDCPProductsListResponse>;
    abstract getComparableBrotherProducts(puid: string): Promise<BDCPComparableBrotherProductsListResponse>;
    abstract getDetails(sku: string): Promise<BDCPProductDetails>;
    abstract getStreetPrice(sku: string, ean: string): Promise<string>;
}
